import {useQuery} from '@tanstack/react-query';
import {apiClient} from '@/shared/services';
import {useAuth} from '@/modules/auth/hooks/useAuth';
import type {LatestOrderResponse, StorefrontOrderData} from '@/shared/types/api';

/** Shared so checkout success paths can invalidate the dashboard's
 *  latest-purchase card (staleTime below otherwise hides a fresh order
 *  for up to 5 minutes after an SPA navigation back to the dashboard). */
export const LATEST_ORDER_QUERY_KEY = ['storefront', 'latest-order'] as const;

export function useLatestOrder(): {order: StorefrontOrderData | null; isLoading: boolean} {
    const {isLoggedIn} = useAuth();
    const {data, isLoading} = useQuery<LatestOrderResponse>({
        queryKey: LATEST_ORDER_QUERY_KEY,
        queryFn: () => apiClient.get<LatestOrderResponse>('/api/storefront/latest-order'),
        enabled: !!isLoggedIn,
        staleTime: 5 * 60 * 1000,
    });
    return {order: data?.order ?? null, isLoading};
}
